import { PayloadAction } from "@reduxjs/toolkit";

import { NavigationState } from "../../types";

export const setClientServiceEventData = (
  state: NavigationState,
  action: PayloadAction<NavigationState["clientEvents"]["service"]["data"]>
) => {
  state.clientEvents.service.data = action.payload;
};

export const setClientServiceEventLoadingStatus = (
  state: NavigationState,
  action: PayloadAction<
    NavigationState["clientEvents"]["service"]["loadingStatus"]
  >
) => {
  state.clientEvents.service.loadingStatus = action.payload;
};
